import DashboardLayout from "components/Layouts/DashboardLayout";
import PageHeader from "components/PageHeader";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { useSelector } from "react-redux";
import { getUsername, getRoles } from "data/app/appSelectors";
import RolesTable from "./RolesTable";
import Language from "./Language";
import Timezone from "./Timezone";

export default function Profile() {
	const { t } = useTranslation();

	const username = useSelector(getUsername);
	const roles = useSelector(getRoles);

	const pageTitle = `${t("main.profile.heading")}: ${username}`;

	return (
		<DashboardLayout>
			<div className="container">
				<PageHeader title={pageTitle} />
				{Object.keys(roles).length && <RolesTable roles={roles} />}
				{i18next.languages.length > 1 && <Language />}
				<Timezone />
			</div>
		</DashboardLayout>
	);
}
